export default {"src":"/_next/static/media/sitter.be97792a.svg","height":21,"width":42,"blurWidth":0,"blurHeight":0};